module.exports = __webpack_public_path__ + "media/images/icons/icon-pix-1c639dffb3325e48991f800e33771592.svg";